import { SpeechSynthesisUtterance } from '@davi-ai/web-speech-cognitive-services-davi'
import createUtterance from './createUtterance'
import type { CreateUtteranceParams } from '../models/speechTypes'
import type { SayAsItem } from '../models/types'

interface SayAs {
  common?: Array<SayAsItem>
  localized?: Record<string, Array<SayAsItem>>
}

/**
 * Check if there are some replacement codes for this language, to improve speech synthesis, and then create the utterance
 * @param {CreateUtteranceParams} params - data needed to create an utterance
 * @param {SayAs} sayAs - string that should be replaced by their ipa codes
 * @returns {SpeechSynthesisUtterance}
 */
const checkSayAsWordsAndCreateUtterance = (params: CreateUtteranceParams, sayAs?: SayAs): SpeechSynthesisUtterance => {
  let sayAsWords: Array<SayAsItem> = []
  if (sayAs) {
    sayAs.common?.length && (sayAsWords = [...sayAs.common])
    sayAs.localized && sayAs.localized[params.locale]?.length && (sayAsWords = [...sayAsWords, ...sayAs.localized[params.locale]])
  }

  return createUtterance({ ...params, sayAsWords })
}

export { checkSayAsWordsAndCreateUtterance }
